import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Bmwcabrentalsnearmeinmumbai() {



  const cardData =
  {
    keyword: 'BMW Cab Rentals Near Me in Mumbai',
    heading: 'Aaryan Travels: BMW Cab Rentals Near Me in Mumbai',
    headingDescription: 'Aaryan Travels offers premium BMW Cab Rentals Near Me in Mumbai for travelers seeking luxury, comfort, and class for business or personal travel. Whether you’re heading for an airport pickup from Chhatrapati Shivaji Maharaj International Airport, attending a high-profile meeting in BKC, or planning a grand wedding entry, our chauffeur-driven BMW sedans deliver a royal travel experience. With uniformed drivers, plush leather interiors, and on-request amenities like Wi-Fi and bottled water, we ensure elegance and convenience across South Mumbai, Bandra, Andheri, Thane, and Navi Mumbai. When you search for BMW cab rentals near me, Aaryan Travels is the most trusted choice for premium travel in Mumbai.',

    top: 'Top Places to Visit in Mumbai with Aaryan Travels',

"topPlaces": [
  {
    "title": "Gateway of India",
    "description": "The Gateway of India, built in 1924 overlooking the Arabian Sea, is the most iconic landmark of Mumbai. It was originally constructed to commemorate the visit of King George V and Queen Mary. Today, it is a popular tourist hub with ferry rides departing to Elephanta Caves. The structure glows beautifully at night, creating a majestic sight. Gateway of India is Mumbai’s proud symbol of colonial history and maritime charm."
  },
  {
    "title": "Marine Drive",
    "description": "Marine Drive, also known as the Queen’s Necklace due to its sparkling streetlights at night, is a 3.6 km-long promenade along the Arabian Sea. Locals and tourists visit for peaceful walks, ocean views, and delicious street snacks like bhel puri. The sunset here is one of the best in the city. Marine Drive is Mumbai’s favorite coastal retreat."
  },
  {
    "title": "Chhatrapati Shivaji Maharaj Terminus (CST)",
    "description": "CST is a UNESCO World Heritage Site and one of the most impressive railway stations in the world. Built in 1887 in Victorian Gothic style, it features stained glass windows, turrets, and spiraled staircases. Despite being a functional station, it looks like a royal monument. Illuminated at night, it offers a spectacular view. CST is Mumbai’s architectural jewel of history and movement."
  },
  {
    "title": "Juhu Beach",
    "description": "Juhu Beach is one of Mumbai’s most popular beaches, known for its bustling crowds and lip-smacking street food like pav bhaji and kulfi. Families enjoy camel rides and kite flying while soaking in the sea breeze. Celebrities often visit the area, adding to its charm. Juhu Beach is Mumbai’s lively sandy hangout."
  },
  {
    "title": "Haji Ali Dargah",
    "description": "Haji Ali Dargah is a 15th-century mosque and tomb located on a small islet off the coast. Connected via a narrow walkway, it appears to float during high tide. People of all faiths visit to seek blessings and experience peaceful spiritual energy. Qawwali performances add to its soulful ambiance. Haji Ali is Mumbai’s tranquil island of devotion."
  },
  {
    "title": "Elephanta Caves",
    "description": "Located on Elephanta Island, these ancient rock-cut caves date back to the 5th century and feature magnificent sculptures of Lord Shiva. The Trimurti statue depicting three aspects of Shiva is the highlight. A scenic ferry ride from the Gateway of India adds to the charm. Elephanta Caves are Mumbai’s timeless marvel sculpted in stone."
  },
  {
    "title": "Siddhivinayak Temple",
    "description": "Siddhivinayak Temple in Prabhadevi is one of Mumbai’s most famous temples dedicated to Lord Ganesha. Devotees, including celebrities and politicians, visit regularly to seek blessings. The gold-plated dome and intricately adorned idol make it visually stunning. Special prayers on Tuesdays draw massive crowds. Siddhivinayak is Mumbai’s divine powerhouse of faith."
  },
  {
    "title": "Bandra-Worli Sea Link",
    "description": "The Bandra-Worli Sea Link is a cable-stayed bridge connecting South Mumbai to the western suburbs. Driving across offers breathtaking views of the sea and the city’s skyline. At night, its illuminated structure looks futuristic and grand. The bridge has greatly reduced travel time and symbolizes modern engineering. The Sea Link is Mumbai’s pride of progress."
  },
  {
    "title": "Colaba Causeway",
    "description": "Colaba Causeway is a vibrant shopping street known for affordable fashion, jewelry, antiques, and handicrafts. Bargain hunters love exploring stalls while enjoying snacks from local vendors. Cafés like Leopold and Mondegar add to its colonial charm. Colaba Causeway is Mumbai’s colorful street market experience."
  },
  {
    "title": "Sanjay Gandhi National Park",
    "description": "Sanjay Gandhi National Park is one of the world’s largest urban forests, offering jungle safaris, trekking trails, and boating experiences. The ancient Kanheri Caves inside the park add archaeological interest. Visitors often spot deer, monkeys, and exotic birds. SGNP is Mumbai’s refreshing escape into nature and history."
  }
],



  "services": [
  {
    "name": "BMW Cab Rentals Near Me in Mumbai",
    "description": "BMW Cab Rentals Near Me in Mumbai provide luxury chauffeur-driven BMWs for business, leisure, and events. Enjoy comfort, style, and premium service across Mumbai with professional drivers."
  },
  {
    "name": "BMW Car Hire Mumbai",
    "description": "BMW Car Hire Mumbai offers a range of BMW models for corporate and personal travel. Ideal for executives and events, this service guarantees elegance and reliability."
  },
  {
    "name": "Chauffeur Driven BMW Mumbai",
    "description": "Chauffeur Driven BMW Mumbai delivers a refined travel experience with professional chauffeurs and luxury BMW vehicles, perfect for business meetings and VIP guests."
  },
  {
    "name": "BMW Taxi Service Mumbai",
    "description": "BMW Taxi Service Mumbai provides high-end taxis equipped with comfort and class. Ideal for airport transfers, business travel, and luxury commutes in Mumbai."
  },
  {
    "name": "Premium BMW Cab Mumbai",
    "description": "Premium BMW Cab Mumbai ensures top-tier comfort and professionalism. With elegant interiors and courteous chauffeurs, it is perfect for corporate and elite travel needs."
  },
  {
    "name": "Executive BMW Rentals Mumbai",
    "description": "Executive BMW Rentals Mumbai cater to business leaders and executives seeking high-quality BMW rides. Enjoy punctual service, privacy, and sophistication throughout your journey."
  },
  {
    "name": "Book BMW Near Me Mumbai",
    "description": "Book BMW Near Me Mumbai offers an easy and quick booking process for luxury BMW cabs. Perfect for those needing on-demand executive-class transport anywhere in the city."
  },
  {
    "name": "Luxury BMW Hire Mumbai",
    "description": "Luxury BMW Hire Mumbai provides premium BMW vehicles with professional chauffeurs for corporate trips, personal events, and special occasions across Mumbai."
  },
  {
    "name": "BMW Sedan Rental Mumbai",
    "description": "BMW Sedan Rental Mumbai offers stylish sedans for smooth, comfortable, and executive travel experiences. Suitable for both business and leisure transportation."
  },
  {
    "name": "BMW with Driver Mumbai",
    "description": "BMW with Driver Mumbai provides luxury BMWs accompanied by trained and courteous chauffeurs. Ideal for city rides, corporate transfers, and VIP clients."
  },
  {
    "name": "Best BMW Rental Mumbai",
    "description": "Best BMW Rental Mumbai delivers the finest BMW models with premium support services. Experience reliable, elegant, and comfortable rides throughout Mumbai."
  },
  {
    "name": "Affordable BMW Taxi Mumbai",
    "description": "Affordable BMW Taxi Mumbai combines luxury with affordability. It’s perfect for travelers who seek BMW comfort and class at competitive rates."
  },
  {
    "name": "Corporate BMW Car Hire Mumbai",
    "description": "Corporate BMW Car Hire Mumbai provides high-end transportation solutions for businesses. Ideal for executives, client travel, and corporate meetings in style."
  },
  {
    "name": "BMW Chauffeur Service Mumbai",
    "description": "BMW Chauffeur Service Mumbai features skilled, uniformed drivers ensuring safe and smooth rides in premium BMW cars. Perfect for corporate and elite travelers."
  },
  {
    "name": "BMW Vehicle Hire Mumbai",
    "description": "BMW Vehicle Hire Mumbai offers flexible rental plans for a fleet of luxury BMWs. Ideal for business trips, events, and personal travel requiring superior comfort."
  }
],
"tableData": [
  ["BMW Cab Rentals Near Me in Mumbai", "BMW Car Hire Mumbai"],
  ["Chauffeur Driven BMW Mumbai", "BMW Taxi Service Mumbai"],
  ["Premium BMW Cab Mumbai", "Executive BMW Rentals Mumbai"],
  ["Book BMW Near Me Mumbai", "Luxury BMW Hire Mumbai"],
  ["BMW Sedan Rental Mumbai", "BMW with Driver Mumbai"],
  ["Best BMW Rental Mumbai", "Affordable BMW Taxi Mumbai"],
  ["Corporate BMW Car Hire Mumbai", "BMW Chauffeur Service Mumbai"],
  ["BMW Vehicle Hire Mumbai", "—"]
],




"whychoose": [
  {
    "WhyChooseheading": "BMW Cab Rentals Near Me in Mumbai",
    "WhyChoosedescription": "Aaryan Travels offers premium BMW cab rentals in Mumbai, providing luxury, comfort, and style right at your doorstep."
  },
  {
    "WhyChooseheading": "Drive in Style with BMW Luxury Cars",
    "WhyChoosedescription": "Experience the elegance of BMW vehicles for your corporate meetings, airport transfers, or special occasions."
  },
  {
    "WhyChooseheading": "Chauffeur-Driven BMW Rentals",
    "WhyChoosedescription": "Enjoy the service of professional, uniformed chauffeurs trained to provide a seamless and luxurious travel experience."
  },
  {
    "WhyChooseheading": "Well-Maintained and Sanitized BMW Fleet",
    "WhyChoosedescription": "Our BMW cabs are regularly cleaned, sanitized, and maintained to ensure safety and top performance."
  },
  {
    "WhyChooseheading": "Transparent and Competitive Pricing",
    "WhyChoosedescription": "Get all-inclusive rental packages with no hidden charges—covering fuel, tolls, and driver fees."
  },
  {
    "WhyChooseheading": "24/7 Assistance and Quick Booking",
    "WhyChoosedescription": "Our dedicated team is available round the clock to help you book a BMW cab whenever you need it."
  },
  {
    "WhyChooseheading": "Flexible Rental Plans for Business or Personal Use",
    "WhyChoosedescription": "Whether for a few hours or the entire day, our BMW rental plans are designed to match your schedule."
  },
  {
    "WhyChooseheading": "Prompt Service Across Mumbai",
    "WhyChoosedescription": "We ensure on-time pickups and drop-offs anywhere in Mumbai, making premium travel easily accessible near you."
  }
]


















  }

const faqData = [
  {
    question: 'Does Aaryan Travels offer BMW cab rentals near me in Mumbai?',
    answer: 'Yes, Aaryan Travels offers premium BMW cab rentals in Mumbai, perfect for business travel, events, or special occasions.',
  },
  {
    question: 'How can I book a BMW cab rental near me in Mumbai with Aaryan Travels?',
    answer: 'You can easily book a BMW cab through our website, mobile app, or by calling our 24x7 customer support team in Mumbai.',
  },
  {
    question: 'What BMW models are available for rental in Mumbai?',
    answer: 'Aaryan Travels offers a selection of high-end BMW models including BMW 5 Series, BMW 7 Series, and other luxury variants for rent in Mumbai.',
  },
  {
    question: 'Are the drivers trained for BMW cab services in Mumbai?',
    answer: 'Yes, our chauffeurs are professionally trained, well-groomed, and experienced in handling luxury BMW cab services in Mumbai.',
  },
  {
    question: 'Can I rent a BMW cab near me in Mumbai for a few hours or a full day?',
    answer: 'Yes, Aaryan Travels provides flexible rental plans for BMW cabs in Mumbai — hourly, half-day, full-day, or multi-day options are available.',
  },
  {
    question: 'Is BMW cab rental service available 24x7 in Mumbai?',
    answer: 'Yes, we offer 24x7 BMW cab rental services in Mumbai to meet your travel needs at any hour.',
  },
  {
    question: 'Are BMW cabs sanitized and maintained for safety?',
    answer: 'Absolutely. All BMW vehicles are cleaned and sanitized thoroughly before every ride, with strict safety protocols in place.',
  },
  {
    question: 'What are the payment options for BMW cab rentals in Mumbai?',
    answer: 'We accept UPI, credit/debit cards, bank transfers, digital wallets, and corporate billing for all BMW cab bookings.',
  },
  {
    question: 'Can I schedule a BMW cab near me in Mumbai in advance?',
    answer: 'Yes, pre-booking is available for BMW cab rentals in Mumbai to ensure timely and luxurious service as per your requirement.',
  },
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Nikhil Sinha',
    feedback: 'Booked a BMW cab with Aaryan Travels in Mumbai — excellent service, spotless car, and a smooth ride. Highly recommend!',
    rating: 5,
  },
  {
    id: 2,
    name: 'Ms. Aarti Malhotra',
    feedback: 'Aaryan Travels made my BMW cab rental experience in Mumbai absolutely luxurious. The driver was punctual and professional.',
    rating: 5,
  },
];



















































  const Images = [
    { place: "/images/keyword/1.jpg", text: "Corporate Cab Services in Pune", link: "corporate-cab-services-in-pune" },
    { place: "/images/keyword/2.jpg", text: "Best Cab Services in Pune", link: "best-cab-services-in-pune" },
    { place: "/images/keyword/3.jpg", text: "Best Cab Services in Kochi", link: "best-cab-services-in-kochi" },
    { place: "/images/keyword/4.jpg", text: "Cab booking from Mumbai to Pune", link: "cab-booking-from-mumbai-to-pune" },
    { place: "/images/keyword/5.jpg", text: "Cab from Pune to Mahabaleshwar", link: "cab-from-pune-to-mahabaleshwar" },
    { place: "/images/keyword/6.jpg", text: "Monthly Cab hire contract in Hyderabad", link: "monthly-cab-hire-contract-in-hyderabad" },
    { place: "/images/keyword/7.jpg", text: "Taxi Services from Pune to Shirdi", link: "taxi-services-from-pune-to-shirdi" },
    { place: "/images/keyword/8.jpg", text: "Pune to Shirdi Cab", link: "pune-to-shirdi-cab" },
    { place: "/images/keyword/9.jpg", text: "Mumbai to Pune Corporate Cab", link: "mumbai-to-pune-corporate-cab" },
    { place: "/images/keyword/10.jpg", text: "Outstation Cab Services from Pune", link: "outstation-cab-services-from-pune" },
    { place: "/images/keyword/11.jpg", text: "Innova Crysta rental in Pune", link: "innova-crysta-rental-in-pune" },
    { place: "/images/keyword/12.jpg", text: "Corporate Cab hire in Pune", link: "corporate-cab-hire-in-pune" },
    { place: "/images/keyword/13.jpg", text: "Pune to Shirdi Corporate Cab booking", link: "pune-to-shirdi-corporate-cab-booking" },
    { place: "/images/keyword/14.jpg", text: "Pune to Mumbai Corporate Cab Services", link: "pune-to-mumbai-corporate-cab-services" },
    { place: "/images/keyword/15.jpg", text: "Monthly Corporate Cab rental in Chennai", link: "monthly-corporate-cab-rental-in-chennai" },
    { place: "/images/keyword/16.jpg", text: "Wedding Corporate Cab bookings in Pune", link: "wedding-cab-bookings-in-pune" },
    { place: "/images/keyword/17.jpg", text: "Corporate Cab Services in Kharadi, Pune", link: "corporate-cab-services-in-kharadi-pune" },
    { place: "/images/keyword/18.jpg", text: "Corporate Cab Services in Ranchi", link: "corporate-cab-services-in-ranchi" },
    { place: "/images/keyword/19.jpg", text: "Corporate Cab Services in Vadodara", link: "corporate-cab-services-in-vadodara" },
    { place: "/images/keyword/20.jpg", text: "Corporate Cab booking in Ranchi", link: "corporate-cab-booking-in-ranchi" },
    { place: "/images/keyword/21.jpg", text: "Corporate Cab booking in Vadodara", link: "corporate-cab-booking-in-vadodara" },
    { place: "/images/keyword/22.jpg", text: "Taxi booking in Ranchi", link: "taxi-booking-in-ranchi" },
    { place: "/images/keyword/23.jpg", text: "Corporate Cab Services in India", link: "corporate-cab-services-in-india" },
    { place: "/images/keyword/24.jpg", text: "Taxi Services in Vadodara, Gujarat", link: "taxi-services-in-vadodara-gujarat" },
    { place: "/images/keyword/25.jpg", text: "Taxi booking in Vadodara", link: "taxi-booking-in-vadodara" }
  ];








const bmwCabRentalsMumbaiSchema = {
  "@context": "https://schema.org",
  "@type": "Service",
  "name": "BMW Cab Rentals Near Me in Mumbai",
  "description": "Aaryan Travels provides premium BMW cab rentals near you in Mumbai with chauffeur-driven BMW cars for executive travel, corporate events, and luxury rides.",
  "provider": {
    "@type": "Organization",
    "name": "Aaryan Travels",
    "url": "https://aaryantravels.com"
  },
  "areaServed": {
    "@type": "City",
    "name": "Mumbai"
  },
  "serviceType": "BMW Cab Rentals",
  "keywords": "BMW Cab Rentals Near Me in Mumbai, BMW Car Hire Mumbai, Chauffeur Driven BMW Mumbai, BMW Taxi Service Mumbai, Premium BMW Cab Mumbai, Executive BMW Rentals Mumbai, Book BMW Near Me Mumbai, Luxury BMW Hire Mumbai, BMW Sedan Rental Mumbai, BMW with Driver Mumbai, Best BMW Rental Mumbai, Affordable BMW Taxi Mumbai, Corporate BMW Car Hire Mumbai, BMW Chauffeur Service Mumbai, BMW Vehicle Hire Mumbai"
};







  return (
    <div>
<Helmet>
  <title>BMW Cab Rentals Near Me in Mumbai | Chauffeur Driven BMW Cabs | Aaryan Travels</title>
  <meta
    name="description"
    content="Book premium BMW cab rentals near you in Mumbai with Aaryan Travels. Chauffeur driven BMW taxis for executive and luxury travel."
  />
  <meta
    name="keywords"
    content="BMW Cab Rentals Near Me in Mumbai, BMW Car Hire Mumbai, Chauffeur Driven BMW Mumbai, BMW Taxi Service Mumbai, Premium BMW Cab Mumbai, Executive BMW Rentals Mumbai, Book BMW Near Me Mumbai, Luxury BMW Hire Mumbai, BMW Sedan Rental Mumbai, BMW with Driver Mumbai, Best BMW Rental Mumbai, Affordable BMW Taxi Mumbai, Corporate BMW Car Hire Mumbai, BMW Chauffeur Service Mumbai, BMW Vehicle Hire Mumbai"
  />
  <script type="application/ld+json">
    {JSON.stringify(bmwCabRentalsMumbaiSchema)}
  </script>
</Helmet>


      <div className="page-headder bg-section parallaxie">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="page-header-box">
                <h1 className="text-anime-style-3" data-cursor="-opaque">
                   {cardData.keyword}
                </h1>
              </div>
            </div>
          </div>
        </div>
      </div>










      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/73.jpg' alt='img' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Aaryan Travels</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Aaryan Travels </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919730707888" className="pc-call">+91 9730707888</a>
                      <a href="tel:+919833377051" className="pc-call">+91 9833377051</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/919730707888"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+919730707888" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:bookings@aaryantravels.com" className="pc-email">
                      bookings@aaryantravels.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Aryan Travels Pune Head Office</strong><br />
                      Flat 304, Plot-82, Prathmesh Krupa, Purnanagar/Chikhali Pune- 411019.
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Bmwcabrentalsnearmeinmumbai;